import axios, {AxiosRequestConfig, AxiosError} from "axios";
import {useEffect, useReducer} from "react";
import {ApiResponse, ApiUseResponse} from "./api_types";
import {addDays, parse} from "date-fns";

const baseConfig: AxiosRequestConfig = {
    ///"https://cremosso-ncp-staging.on.syscomdigital.ro"
    baseURL: ['development', 'dev'].indexOf((process as any).env.NODE_ENV) > -1 ?  "https://cremosso-ncp-staging.on.syscomdigital.ro" :
        (((process as any).env.PUBLIC_URL.indexOf('-staging') > -1 || (process as any).env.PUBLIC_URL.indexOf('localhost') > -1) ? "https://cremosso-ncp-staging.on.syscomdigital.ro" :
            "https://cremosso.ro")
};

export const isDevelopment = ():boolean => {
    return  (process as any).env &&
        (['development', 'dev', 'dev1'].indexOf((process as any).env.NODE_ENV) > -1
            || ['development', 'dev', 'dev1'].indexOf((process as any).env.NODE_ENV) > -1);
}
export const isStaging = (): boolean => {
    return window?.location?.href.indexOf('-staging') !== -1;
}
export const isStagingOrDev= (): boolean => {
    return isStaging() || isDevelopment();
}

export const warn = (...input:any[]) => {
    if (isStagingOrDev()){
        console.log(...input)
    }

}

export class ApiHelper {

    private static ApiPathCampanie22Q1 = "a22q1";
    private static ApiPathCampanie21Q4 = "a21q4";

    private static ApiPathCampanieCurrent() {
        return this.ApiPathCampanie22Q1;
    }

    static ApiParticipa = `/api/${this.ApiPathCampanieCurrent()}/participa/`
    static ApiCastigatori = `/api/${this.ApiPathCampanieCurrent()}/castigatori/`
    static ApiCsTrack = `/api/${this.ApiPathCampanieCurrent()}/cs-track/`

    static ApiIdCsTrackVideoStart  = 107
    static ApiIdCsTrackVideoStop  = 108

    static campHasEnded = (ultime_zi_de_participare: string): boolean => {
    let dataEnd = parse(ultime_zi_de_participare, 'yyyy-MM-dd', new Date())
    let firstDateAfterEndAtHour00 = addDays(dataEnd, 1);
    //>= pt ca new Date e cu ora:minut:secunda 00:00:00 asa ca luam urmatoare zi pt comparatie
    return new Date() >= firstDateAfterEndAtHour00;
}

}

interface ApiGetStateType<T> extends ApiResponse<T> {
    dataLoading: boolean,
}

export function useApiPost<T>(url: string, postData: any): ApiUseResponse<T> {

    const [state, setState] = useReducer(
        (state: ApiGetStateType<T>, newState: any) => {
            return ({...state, ...newState})
        },
        {
            data: {} as T,
            dataLoading: true,
        }
    )

    useEffect(() => {
        if (url === undefined || url.length === 0) return
        setState({dataLoading: true})
        const fetchData = async () => {
            try {
                let apiResponse = await apiPost<T>(url, postData)
                setState(apiResponse)
            } catch (e) {
                setState({status: 0, errorMessage: "Procesare nereusita.", dataLoading: false})
            }
        };
        fetchData().then(r => r)
    }, [url, postData]);

    return state;
}

export async function apiPost<T>(url: string, data: any): Promise<ApiResponse<T>> {

    let headers = {
        'Content-Type': 'multipart/form-data',
    }

    const axiosConfig = {
        ...baseConfig,
        headers,
    };

    let formData = data;
    if (!(formData instanceof FormData)) {
        formData = new FormData();
        for (let key of Object.keys(data)) {
            formData.set(key, data[key]);
        }
    }

    return await axios.post<T>(url, formData, axiosConfig)
        .catch(catchAxiosError)
        .then((res: any) => {
            if ('apiCallSuccess' in res) {
                return res as ApiResponse
            }
            return Object.assign(res, {apiCallSuccess: true, errorMessage: ''}) as ApiResponse
        })
}


export function catchAxiosError<T>(err: AxiosError): ApiResponse<T> {
    // Something happened in setting up the request that triggered an Error
    console.log("Error", err.message);
    let message = "Error processing your request.";
    let errorResponse = err.response
    if (errorResponse) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(response);
        // message = response.data.message;
        message = "Procesare nereusita."
    } else if (err.request) {
        // The request was made but no response was received
        // `err.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // console.log(err.request);
        message = "Procesare nereusita.";
    }
    return {
        status: 0,
        statusText: "",
        headers: {},
        config: {},
        apiCallSuccess: false,
        errorMessage: message,
        data: {} as T
    };
}
